import {
    ConsoleFormattedStream,
    createLogger,
    stdSerializers
} from "browser-bunyan";
import * as React from "react";
import Auth from "./login/auth";

const log = createLogger({
    name: 'console',
    serializers: stdSerializers,
    src: true,
    streams: [
        {
            level: "trace",
            stream: new ConsoleFormattedStream()
        }
    ]
});

// Setup authorization handler with redirect path set to /renew
const auth = new Auth("renew");

export default function Renew() {
    // Enable renewal request from application window
    window.document.addEventListener("requestTokenRenew", requestRenew, false);

    // Default autorenew interval set to every 10 minutes
    let msToNextRenew = 600000;

    // Handle access token if present in request
    if (location.hash.indexOf("access_token") > 0) {
        // We are receiving a new access token - store the token in session
        // storage then notify the parent window that renewal has taken place
        log.debug("Receiving new auth token");
        auth.getToken(window.location).then(notifyRenewed);
    } else {
        // We are not currently receiving an access token - check if a token
        // is already in session storage and if so check how long until
        // it expires
        let msToExpiry: number | undefined;
        if (auth.token != null) {
            log.debug("Access token found");
            const expires: Date = (auth.token as any).expires;
            msToExpiry = expires.getTime() - new Date().getTime();
            log.debug(`Expires in ${msToExpiry} ms`);
        } else {
            log.debug("No access token found");
        }

        // If token expires before next autorenew interval, renew immediately
        if (msToExpiry != null && msToExpiry < msToNextRenew) {
            msToNextRenew = 50;
        }
    }

    // Call for token renewal automatically when timeout expires
    log.debug(`Automatically renewing in ${msToNextRenew} ms`);
    window.setTimeout(requestRenew, msToNextRenew);

    return <React.Fragment />;
}

// Redirect to login window with prompt=none to avoid user interaction
function requestRenew() {
    log.debug("Attempting silent renew of auth token")
    const uri = auth.getLogInUri({ query: { prompt: "none" } });
    location.href = uri;
}

// Notify parent window of renewal
function notifyRenewed() {
    const event = new CustomEvent("tokenRenewed");
    window.parent.document.dispatchEvent(event);
}



// WEBPACK FOOTER //
// ./src/renew.tsx